import React, { Component, Fragment } from "react";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Brand from "../elements/Brand";
import Helmet from "../component/common/Helmet";
import Footer from "../component/footer/Footer";
import TabThree from "../elements/tab/TabThree";

const SlideList = [
  {
    textPosition: "text-center",
    category: "",
    title: "",
    description: "",
    buttonText: "Contact Us",
    buttonLink: "/contact",
    bgImage: "/assets/images/house/homebg.jpeg",
  },
];

class HomePortfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
  }

  componentDidMount() {
    if (window.location.hash === "#land-section") {
      setTimeout(() => {
        const el = document.getElementById("land-section");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }

  toggleShowMore = () => {
    this.setState((prevState) => ({ showMore: !prevState.showMore }));
  };

  render() {
    const { showMore } = this.state;

    return (
      <Fragment>
        <Helmet pageTitle="Home Portfolio" />

        <Header />

        {/* Start Slider Area */}
        <div className="slider-wrapper">
          {SlideList.map((value, index) => (
            <div
              key={index}
              className="slide slide-style-2  d-flex align-items-center justify-content-center"
              style={{
                backgroundImage: `url(${value.bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "transparent",
                height: "50vh",
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className={`inner ${value.textPosition}`}>
                      {value.category && <span>{value.category}</span>}
                      {value.title && (
                        <h1 className="title theme-gradient">{value.title}</h1>
                      )}
                      {value.description && (
                        <p className="description">{value.description}</p>
                      )}
                      {/* <a href="/">
                        <img
                          src={logoDefault}
                          alt="Digital Agency"
                          style={{
                            maxWidth: "350px", // genişliği sınırla
                            height: "auto", // oran korunsun
                            objectFit: "contain",
                          }}
                        />
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* End Slider Area */}

        {/* Start portfolio Area  */}
        <div className="rn-portfolio-area bg_color--1 ptb--120">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center mb--30">
                  <h2 className="title">Properties for Sale</h2>

                  {/* İlk paragraf her zaman görünecek */}
                  <p>
                    At Grand Maple Properties, we believe that finding a home is
                    far more than a transaction — it is the beginning of a
                    story. We don’t sell properties; we curate spaces that
                    reflect the individuality, values, and aspirations of our
                    clients.
                  </p>

                  {/* Diğer paragraflar sadece showMore=true olduğunda görünsün */}
                  {showMore && (
                    <>
                      <p>
                        Whether it’s a secluded villa overlooking the Göcek Bay,
                        a modern residence in Fethiye or a villa in Üzümlü set
                        among olive groves, or an investment property by the
                        coast, every search begins with understanding your
                        lifestyle before presenting a single key.
                      </p>
                      <p>
                        Our approach is built on discretion, trust, and deep
                        local knowledge. With years of expertise in Turkey's
                        most sought-after coastal regions, we combine an
                        insider’s perspective with an international standard of
                        service. From private viewings and architectural
                        consultations to legal guidance and after-sale care, we
                        offer a seamless experience tailored to your needs.
                      </p>
                      <p>
                        At Grand Maple Properties, you are not one of many — you
                        are the one. Every recommendation, every detail, and
                        every step is shaped exclusively around you.
                      </p>
                    </>
                  )}

                  {/* Devamını Oku / Daha Az Göster Butonu */}
                  <button
                    onClick={this.toggleShowMore}
                    className="rn-btn btn-solid mt--20"
                  >
                    {showMore ? "Show Less" : "Read More"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Start Designer Portfolio  */}
          <div className="designer-portfolio-area bg_color--1">
            <div className="wrapper plr--70 plr_sm--30 plr_md--30">
              <TabThree
                column="col-lg-6 col-md-6 col-sm-6 col-12"
                dataType="house"
              />
            </div>
          </div>
          {/* End Designer Portfolio  */}

          {/* Lands for sale */}
          <div
            id="land-section"
            className="rn-portfolio-area bg_color--1 ptb--120"
          >
            <div className="container text-center mb--30">
              <h2 className="title">Land for Sale</h2>
            </div>

            <div className="designer-portfolio-area bg_color--1">
              <div className="wrapper plr--70 plr_sm--30 plr_md--30">
                <TabThree
                  column="col-lg-6 col-md-6 col-sm-6 col-12"
                  dataType="land"
                />
              </div>
            </div>
          </div>
          {/* End Lands for sale */}
        </div>
        {/* End portfolio Area  */}

        <Footer />

        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
      </Fragment>
    );
  }
}

export default HomePortfolio;
